import defineRule from '../defineRule';
const isDomainRegex = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/;
export function isValidDomain(domain) {
    return isDomainRegex.test(`${domain}`);
}
defineRule('validDomain', (domain) => {
    return isValidDomain(`${domain}`) || `Please enter a valid domain`;
});
